import React from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { hasPermissionsFor } from 'helpers/_helpers';
import styles from './styles';
import { drawerTypes } from '../helpers/drawerTypes';
import { useNavigate } from '../../../../../node_modules/react-router-dom/index';
import ExportExcelButton from 'pages/TimeClock/components/ExportExcelButton/ExportExcelButton';

const EquipmentHeader = ({ classes, openDrawer, handleExcelExport }) => {
  const navigate = useNavigate();

  const onEquipmentScheduleClick = () => {
    navigate('/equipment-schedule-order')
  }

  const displayExportButton = hasPermissionsFor('equipmentFullAccess') ||
    hasPermissionsFor('worklogsRead') ||
    hasPermissionsFor('worklogsFullAccess') ||
    hasPermissionsFor('worklogsEdit')

  return (
    <header className={classes.header}>
      <div className={classes.headerTitle}>
        <Typography variant="h3">Equipment</Typography>
        {hasPermissionsFor('equipmentFullAccess') ? (
          <Button
            variant="outlined"
            color="primary"
            className={classes.equipmentScheduleBtn}
            onClick={onEquipmentScheduleClick}
            disableTouchRipple
          >
            Schedule Display Order
          </Button>
        ) : null}
      </div>
      <div className={classes.headerTitle}>
        {displayExportButton ? (
          <ExportExcelButton onClick={handleExcelExport} />
        ) : null}
        {hasPermissionsFor('equipmentFullAccess') && (
          <Button
            variant="text"
            color="secondary"
            className={classes.addButton}
            onClick={openDrawer(drawerTypes.create)}
            disableTouchRipple
          >
            + Add Equipment
          </Button>
        )}
      </div>
    </header>
  );
};

EquipmentHeader.propTypes = {
  classes: propTypes.object.isRequired,
  openDrawer: propTypes.func.isRequired,
};

export default withStyles(styles)(EquipmentHeader);
